import { IUserAvatar, IUserPopover, UserPopoverContentComponent } from '@aston/user-badge';
import { NgbDropdownModule, NgbTooltipModule } from '@ng-bootstrap/ng-bootstrap';
import { TranslateModule, TranslateService } from '@ngx-translate/core';
import { MultiSearchInputComponent } from '@aston/multi-search-input';
import { PageHeaderComponent } from '@aston/foundation/components';
import { AppLanguage, ActionType } from '@aston/foundation/enums';
import { Component, inject, input, output } from '@angular/core';
import { ClipboardService } from '@aston/foundation/services';
import { UnsubscriberClass } from '@aston/foundation/classes';
import { AsyncPipe, UpperCasePipe } from '@angular/common';
import { LanguagePipe } from '@aston/foundation/pipes';
import { ISearchItem } from '@aston/foundation/models';
import { IAction } from '@aston/foundation/models';
import { Store } from '@ngrx/store';

import { UserNotificationsStore } from '../../../notifications-module/stores';
import * as AppStoreSelectors from '../../../root-store/app-store/selectors';
import { UserAvatarComponent } from '../user-avatar/user-avatar.component';
import { UserClearanceLevel } from '../../../authentication-module/enums';
import * as AppStoreActions from '../../../root-store/app-store/actions';
import { WorkflowSchedulingStore } from '../../../admin-module/store';
import { environment } from '../../../../environments/environment';
import { BrandingPipe } from '../../pipes/branding.pipe';

import { TopBarSearchStore } from './top-bar.search.store';

@Component({
	selector: '[layout-top-bar]',
	templateUrl: './top-bar.component.html',
	imports: [
		TranslateModule,
		NgbDropdownModule,
		PageHeaderComponent,
		MultiSearchInputComponent,
		UserAvatarComponent,
		AsyncPipe,
		BrandingPipe,
		UpperCasePipe,
		LanguagePipe,
		NgbTooltipModule,
		UserPopoverContentComponent,
	],
	providers: [TopBarSearchStore]
})
export class TopBarComponent extends UnsubscriberClass {
	protected store = inject(Store);
	protected searchStore = inject(TopBarSearchStore);
	protected workflowSchedulingStore = inject(WorkflowSchedulingStore);
	protected notifications = inject(UserNotificationsStore);
	protected i18n = inject(TranslateService);
	protected branding = inject(BrandingPipe);
	protected cb = inject(ClipboardService);

	currentLanguage = input<AppLanguage>();
	user = input<IUserAvatar>();
	tenantName = input<string>();
	tenantLogo = input<string>();
	userInfos = input<IUserPopover>();

	selectLanguage = output<AppLanguage>();
	logout = output<void>();
	action = output<IAction>();

	fr = AppLanguage.FR;
	en = AppLanguage.EN;
	hasTranslations = environment.translations.enabled;
	path = window.location.href;

	config$ = this.store.select(AppStoreSelectors.selectConfig);
	operator$ = this.store.select(AppStoreSelectors.selectCurrentUser);

	searchGroups = this.searchStore.results;
	searchResultsWithMore = this.searchStore.sortedResultsWithMore;

	setLanguage(language: AppLanguage) {
		this.selectLanguage.emit(language);
	}

	userLogout() {
		this.logout.emit();
	}

	leavePlatform() {
		this.store.dispatch(AppStoreActions.NavigateToConsole({path: '/dashboard/subsidiaries'}))
	}

	editMyInformations() {
		this.store.dispatch(AppStoreActions.NavigateToGate({path: '/Account/edit?ReturnUrl=' + encodeURIComponent(this.path)}))
	}

	toggleNotificationsPanel() {
		this.action.emit({type: ActionType.TOGGLE, value: 'notifications'});
	}

	toggleThemesPanel() {
		this.action.emit({type: ActionType.TOGGLE, value: 'themes'});
	}

	userMenuOpened() {
		this.action.emit({type: ActionType.OPEN, value: 'user'});
	}

	openHelp() {
		this.store.dispatch(AppStoreActions.NavigateToHelpPage())
	}

	cpcSupportPhone() {
		const text = this.i18n.instant('TopBar.Tooltip.Contact').split(':').pop().trim()
		this.cb.writeText(text)
	}

	get canUpdatePlatform$(){
		return this.store.select(AppStoreSelectors.selectClearsLevel(UserClearanceLevel.UpdatePlatform));
	}

	updatePlatform(){
		this.store.dispatch(AppStoreActions.OpenConfirmationModal(
			{textsKey: 'Modal.UpdatePlatform.'},
			AppStoreActions.Execute(() => this.workflowSchedulingStore.startConfig())));
	}

	search(term: string) {
		this.searchStore.search(term);
	}

	pickSearchResult(item: ISearchItem) {
		this.searchStore.select(item);
	}
	
}
